//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import XLSX from 'xlsx';
export default {
  name: 'CouponProductsImport',
  props: {
    onSuccess: {
      type: Function,
      required: true
    },
    currentProducts: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },
  methods: {
    handleUpload: function handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    handleClick: function handleClick(e) {
      var files = e.target.files;
      var rawFile = files[0]; // only use files[0]
      if (!rawFile) return;
      this.upload(rawFile);
    },
    upload: function upload(rawFile) {
      this.$refs['excel-upload-input'].value = null; // fix can't select the same excel
      this.readerData(rawFile);
    },
    readerData: function readerData(rawFile) {
      var _this = this;
      this.loading = true;
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (e) {
          try {
            var data = e.target.result;
            var workbook = XLSX.read(data, {
              type: 'array'
            });
            var firstSheetName = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[firstSheetName];
            var header = _this.getHeaderRow(worksheet);
            var results = XLSX.utils.sheet_to_json(worksheet);

            // Process the imported products
            if (results && results.length > 0) {
              var importedProducts = results.map(function (item) {
                return {
                  id: item['ID'],
                  skuCode: item['编码'],
                  skuName: item['名称'],
                  otPrice: item['零售价'],
                  listStatus: item['状态'] === '已上架' ? 1 : 0,
                  brandName: item['品牌'],
                  supplierName: item['供应商']
                };
              }).filter(function (item) {
                return item.id;
              }); // Filter out entries without IDs

              // Check for duplicates with current products
              var existingIds = _this.currentProducts.map(function (item) {
                return item.id;
              });
              var newProducts = importedProducts.filter(function (item) {
                return !existingIds.includes(item.id);
              });
              var duplicateCount = importedProducts.length - newProducts.length;
              if (duplicateCount > 0) {
                _this.$message.warning("\u6210\u529F\u5BFC\u5165 ".concat(newProducts.length, " \u4E2A\u5546\u54C1\uFF0C").concat(duplicateCount, " \u4E2A\u5546\u54C1\u5DF2\u5B58\u5728\u88AB\u5FFD\u7565"));
              } else if (newProducts.length > 0) {
                _this.$message.success("\u6210\u529F\u5BFC\u5165 ".concat(newProducts.length, " \u4E2A\u5546\u54C1"));
              } else {
                _this.$message.warning('未找到新的有效商品数据');
              }

              // 返回成功导入的商品列表
              _this.onSuccess(newProducts);
            } else {
              _this.$message.warning('未找到有效商品数据');
            }
          } catch (error) {
            console.error('导入失败:', error);
            _this.$message.error('导入失败，请检查文件格式');
          } finally {
            _this.loading = false;
            resolve();
          }
        };
        reader.onerror = function () {
          _this.$message.error('读取文件失败');
          _this.loading = false;
          reject();
        };
        reader.readAsArrayBuffer(rawFile);
      });
    },
    getHeaderRow: function getHeaderRow(sheet) {
      var headers = [];
      var range = XLSX.utils.decode_range(sheet['!ref']);
      var C;
      var R = range.s.r;
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        var cell = sheet[XLSX.utils.encode_cell({
          c: C,
          r: R
        })];
        /* find the cell in the first row */
        var hdr = 'UNKNOWN ' + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    isExcel: function isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
    downloadTemplate: function downloadTemplate() {
      // 创建工作簿
      var workbook = XLSX.utils.book_new();

      // 示例数据
      var exampleData = [{
        'ID': '1001',
        '编码': 'SKU001',
        '名称': '示例商品1',
        '零售价': '99.00',
        '状态': '已上架',
        '品牌': '品牌A',
        '供应商': '供应商A'
      }, {
        'ID': '1002',
        '编码': 'SKU002',
        '名称': '示例商品2',
        '零售价': '199.00',
        '状态': '未上架',
        '品牌': '品牌B',
        '供应商': '供应商B'
      }];

      // 创建工作表
      var worksheet = XLSX.utils.json_to_sheet(exampleData);

      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(workbook, worksheet, '商品导入模板');

      // 导出工作簿并下载
      XLSX.writeFile(workbook, '优惠券商品导入模板.xlsx');
    }
  }
};